import React from 'react';
import { useIntlBds } from '../../../../../translations/BdsIntlProvider';
import { Box } from '../../../../Box';
import { Divider } from '../../../../Divider';
import { Button } from '../../../../Button';
import { Tooltip } from '../../../../Tooltip';
import { styled } from '../../../../../styles';
import { Typography } from '../../../../Typography/Typography';
import { useDataTableContext } from '../../context/DataTableContext';

export const BulkToolbar: React.FC = () => {
  const { slotProps, state, pageModel } = useDataTableContext();
  const { intl, format } = useIntlBds();
  const selectedRowsData = state.selectedRows.map((it) => it.data);
  const selectedRowsMessage = format(intl.DataTable.BulkActions.selected, {
    count: selectedRowsData.length,
    totalCount: pageModel.totalCount
  });

  return (
    <StyledBulkToolbar>
      {slotProps?.bulkToolbar?.beforeActions ?? <Typography variant="body">{selectedRowsMessage}</Typography>}
      {slotProps?.bulkToolbar?.actions.map((action, index) => {
        if (action.type === 'custom') {
          return <React.Fragment key={action.key}>{action.render(selectedRowsData)}</React.Fragment>;
        }
        if (action.type === 'separator') {
          return <Divider orientation="vertical" flexItem key={`divider-${index}`} />;
        }
        return (
          <Tooltip title={action.disabled ? action.disabledMessage : action.tooltipText} key={action.label}>
            <span>
              <Button
                variant="outlined"
                startIcon={action.iconName}
                dataTest={action.dataTest}
                disabled={action.disabled}
                onClick={() => action.onClick(selectedRowsData)}
              >
                {action.label}
              </Button>
            </span>
          </Tooltip>
        );
      })}
      {slotProps?.bulkToolbar?.afterActions}
    </StyledBulkToolbar>
  );
};

const StyledBulkToolbar = styled(Box)`
    padding: ${({ theme }) => theme.spacing(5)};
    background-color: #f3f7fb; // theme.tokens.surfaceTonesLevel1 but without transparency
    position: absolute;
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    
    button[disabled] {
        opacity: 0.5;
    }
`;
